import { useState } from "react";
import { useParams } from "react-router-dom";

//Bootstrap
import { Card } from "react-bootstrap";

//Icons
import { MdEdit } from "react-icons/md";

//components
import OstaliPartnerjiCardItemEditForm from "./OstaliPartnerjiCardItemEditForm";

//API calls
import { useDeletePartnerFromProject } from "../../../../services/ProjectDetails/partnerskeOrganizacijeAPI";

//UI components
import Field from "../../../ui/Field";
import DeleteModal from "../../../ui/DeleteModal";
import ErrorMessage from "../../../ui/ErrorMessage";
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const OstaliPartnerjiCardItem = ({ partner }) => {
  const { id } = useParams();
  const { project } = useProjectDetailsContext();

  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  //DELETE other partner
  const {
    mutate: deletePartnerFromProject,
    isPending: isPending,
    isError,
    error,
    reset: resetMutationError,
  } = useDeletePartnerFromProject(id, partner.partnerID);

  const onEditClick = () => {
    setIsEditing(true);
  };

  const onDeleteOtherPartnerClick = () => {
    deletePartnerFromProject({
      onSuccess: () => {
        setShowDeleteModal(false);
      },
      onError: () => {
        setTimeout(() => {
          resetMutationError();
        }, 3000);
        setShowDeleteModal(false);
      },
    });
  };

  return (
    <>
      <Card className="mb-3 mt-3">
        <div className="d-flex align-items-center justify-content-between px-3 pt-3">
          <h5 className="mb-0">{partner?.nazivSlo}</h5>
          {!isEditing && (
            <RoleGuard
              moduleKey={MODULES.PROJEKTI}
              roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
              vodilnaClanicaProjektaID={project?.clanicaID}
            >
              <div>
                <button
                  className="btn btn-sm btn-outline-primary uredi-btn-tab-card-header border-0"
                  onClick={onEditClick}
                  disabled={isEditing}
                >
                  <span className="d-flex align-items-center gap-1">
                    Uredi <MdEdit />
                  </span>
                </button>
                <button
                  className="btn btn-sm btn-outline-danger border-0"
                  onClick={() => setShowDeleteModal(true)}
                  disabled={isEditing}
                >
                  <span className="d-flex align-items-center gap-1">
                    Izbriši
                  </span>
                </button>
              </div>
            </RoleGuard>
          )}
        </div>
        {!isEditing && (
          <div className="px-3 pb-3">
            <div className="mb-1">
              <Field
                label="Vloga partnerja"
                value={partner?.vloga}
                showLabel={false}
                className="mb-2 text-primary fw-bold"
              />
            </div>
            <div className="mb-1">
              <Field
                label="Vodja projekta"
                className={"mb-0"}
                value={partner?.vodjaProjekta}
              />
            </div>
            <div className="mb-0">
              <Field label="Kontaktna oseba" value={partner?.kontaktnaOseba} />
            </div>
          </div>
        )}
        {isEditing && (
          <OstaliPartnerjiCardItemEditForm
            partner={partner}
            setIsEditing={setIsEditing}
          />
        )}
      </Card>

      {isError && (
        <ErrorMessage
          message={error?.message || "Prišlo je do napake"}
          show={isError}
        />
      )}

      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={() => {
          onDeleteOtherPartnerClick(partner.partnerID);
        }}
        naziv={partner.nazivSlo}
        isPending={isPending}
        text="Ali ste prepričani, da želite iz projekta odstraniti partnerja:"
      />
    </>
  );
};

export default OstaliPartnerjiCardItem;
